// ข้อมูลผู้สั่งซื้อสำหรับออกใบกำกับภาษี/ใบเสร็จ/ใบแจ้งหนี้ — กรอกที่หน้า checkout (EnrollCourse) หรือหน้ายอมรับ
// ใบเสนอราคา (InhouseRequest) แล้วส่งไปบันทึกจริงที่ backend (t_billing_info)
export type RecipientType = 'INDIVIDUAL' | 'COMPANY'

export interface InvoiceInfo {
  wantsInvoice: boolean       // เฉพาะกรณีเลือกประเภท "บุคคลทั่วไป" — เลือกได้ว่าจะเอาเอกสารไหม (นิติบุคคล/บริษัทตอนซื้อคอร์สบังคับเสมอ)
  recipientType: RecipientType
  fullName: string            // บุคคลทั่วไป
  companyName: string         // นิติบุคคล/บริษัท
  taxId: string
  branchCode: string          // นิติบุคคล/บริษัท เท่านั้น
  address: string
  province: string
  district: string            // เขต/อำเภอ
  subdistrict: string         // แขวง/ตำบล
  postalCode: string
}

export const emptyInvoiceInfo = (recipientType: RecipientType, wantsInvoice: boolean): InvoiceInfo => ({
  wantsInvoice, recipientType, fullName: '', companyName: '', taxId: '', branchCode: '',
  address: '', province: '', district: '', subdistrict: '', postalCode: '',
})

// รูปแบบที่ backend คืนมา (t_billing_info ผ่าน BillingInfoSchema) — เก็บถาวรแล้ว มี doc_number/doc_type จริง
export interface BillingInfo {
  doc_type: 'RECEIPT' | 'INVOICE'
  doc_number: string | null
  recipient_type: RecipientType
  full_name: string | null
  company_name: string | null
  tax_id: string | null
  branch_code: string | null
  address: string | null
  province: string | null
  district: string | null
  subdistrict: string | null
  postal_code: string | null
}

// แปลง state ฟอร์ม (camelCase) เป็น body ที่ backend รับ (snake_case) — ใช้ตอนส่งไปกับ payOrder()/acceptInhouseRequest()
// คืน undefined ถ้าไม่ต้องส่งอะไรเลย (บุคคลทั่วไปไม่ได้ติ๊กขอเอกสาร) — backend จะตีความเป็น "ไม่ออกเอกสาร" เอง
export function toBillingInfoPayload(info: InvoiceInfo) {
  if (info.recipientType === 'INDIVIDUAL' && !info.wantsInvoice) return undefined
  return {
    recipient_type: info.recipientType,
    wants_invoice: info.wantsInvoice,
    full_name: info.fullName || undefined,
    company_name: info.companyName || undefined,
    tax_id: info.taxId || undefined,
    branch_code: info.branchCode || undefined,
    address: info.address || undefined,
    province: info.province || undefined,
    district: info.district || undefined,
    subdistrict: info.subdistrict || undefined,
    postal_code: info.postalCode || undefined,
  }
}
